// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   Chip,
//   Modal,
//   TextField,
//   Stack,
//   List,
//   ListItem,
//   ListItemText,
//   Tabs,
//   Tab,
//   CircularProgress,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import {
//   Visibility,
//   Edit,
//   Close as CloseIcon,
// } from "@mui/icons-material";
// import api from "../../../api/axiosInterceptor";
// import { API_BASE_URL } from "../../../config";
// import TableComponent from "../../../Components/TableComponent/TableComponent";
// import { LoadingSpinner } from "../../../Components/spinner/spinner";
// import { SnackBarComponent } from "../../../Components/snackBar/snackBar";
// import ClaimDetailPage from "../claimView";

// // Docs modal style (taller for tabs)
// const docsStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 600,
//   maxHeight: "80vh",
//   bgcolor: "background.paper",
//   borderRadius: 2,
//   boxShadow: 24,
//   p: 0,
//   display: "flex",
//   flexDirection: "column",
// };

// // Edit modal style (your original compact style)
// const editStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   borderRadius: 2,
//   boxShadow: 24,
//   p: 4,
// };

// export default function ClaimVer1List() {
//   const [rows, setRows] = useState([]);
//   const [originalRows, setOriginalRows] = useState([]); // Store original unfiltered data
//   const [loading, setLoading] = useState(true);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });
//   const [selectedClaimId, setSelectedClaimId] = useState(null);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [editFormData, setEditFormData] = useState({
//     ver_1_remarks: "",
//     ver1_assesment_amt: "",
//     is_verified_1: false,
//   });

//   // Filter states
//   const [feFilter, setFeFilter] = useState("all");
//   const [uniqueFEs, setUniqueFEs] = useState([]);

//   // Docs Modal states
//   const [docsModal, setDocsModal] = useState({
//     open: false,
//     claimId: null,
//     docs: [],
//     loading: false,
//     activeTab: 0, // 0=Add, 1=View
//   });
//   const [newDocName, setNewDocName] = useState("");

//   const showSnackbar = (msg, sev = "info") =>
//     setSnackbar({ open: true, message: msg, severity: sev });
//   const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "Rejected":
//         return "error";
//       case "CA Verified":
//         return "success";
//       case "In Progress":
//         return "warning";
//       case "Submitted":
//         return "info";
//       case "Draft":
//         return "default";
//       default:
//         return "default";
//     }
//   };

//   const getApplicationType = (isNormal, isDelayed) => {
//     if (isNormal) return "Normal";
//     if (isDelayed) return "Delayed";
//     return "Normal"; // default
//   };

//   const fetchClaims = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get(`/claim-mgmt/ver1-claims-mgmt/`);
//       const data = await Promise.all(
//         res.data.map(async (item, idx) => {
//           const csb = Array.isArray(item.claim_status_base)
//             ? item.claim_status_base[0]
//             : item.claim_status_base;

//           const status = csb
//             ? csb.is_rejected
//               ? "Rejected"
//               : csb.is_ca_verified
//               ? "CA Verified"
//               : csb.is_verified_2 || csb.is_verified_1
//               ? "In Progress"
//               : csb.is_submited
//               ? "Submitted"
//               : "Draft"
//             : "Unknown";

//           let additionalDocsData = [];
//           try {
//             const docsRes = await api.get(
//               `/claim-mgmt/additional-docs1/${item.id}/`
//             );
//             additionalDocsData = docsRes.data || [];
//           } catch (err) {
//             additionalDocsData = [];
//           }

//           return {
//             id: item.id,
//             slNo: idx + 1,
//             claimant_name: item.name_of_claimant1 || "-",
//             fe_name: item.fe_name || "-",
//             ack_no: item.ack_no || "-",
//             application_type: getApplicationType(item.is_normal, item.is_delayed),
//             created: item.created
//               ? new Date(item.created).toLocaleDateString("en-GB")
//               : "-",
//             status,
//             additionalDocsData,
//             fullData: item,
//           };
//         })
//       );
      
//       // Store original data
//       setOriginalRows(data);
      
//       // Apply current filter to the new data
//       if (feFilter === "all") {
//         setRows(data);
//       } else {
//         const filtered = data.filter(row => row.fe_name === feFilter);
//         setRows(filtered);
//       }
      
//       // Extract unique FE names for filter dropdown
//       const feNames = [...new Set(data.map(row => row.fe_name).filter(name => name && name !== "-"))];
//       setUniqueFEs(feNames);
      
//     } catch (err) {
//       console.error("fetchClaims", err);
//       showSnackbar("Failed to load claims", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Apply filter based on selected FE
//   const applyFeFilter = () => {
//     if (feFilter === "all") {
//       setRows(originalRows);
//     } else {
//       const filtered = originalRows.filter(row => row.fe_name === feFilter);
//       setRows(filtered);
//     }
//   };

//   // Handle FE filter change
//   const handleFeFilterChange = (event) => {
//     const value = event.target.value;
//     setFeFilter(value);
    
//     if (value === "all") {
//       setRows(originalRows);
//     } else {
//       const filtered = originalRows.filter(row => row.fe_name === value);
//       setRows(filtered);
//     }
//   };

//   const fetchAdditionalDocs = async (claimId) => {
//     try {
//       const res = await api.get(`/claim-mgmt/additional-docs1/${claimId}/`);
//       return res.data || [];
//     } catch (err) {
//       console.error("fetchAdditionalDocs", err);
//       return [];
//     }
//   };

//   useEffect(() => {
//     fetchClaims();
//   }, []);

//   const handleRequestDocsClick = async (claimId) => {
//     setDocsModal({ open: true, claimId, docs: [], loading: true, activeTab: 0 });
//     const docs = await fetchAdditionalDocs(claimId);
//     setDocsModal(prev => ({ ...prev, docs, loading: false }));
//   };

//   const handleDocsTabChange = (event, newValue) => {
//     setDocsModal(prev => ({ ...prev, activeTab: newValue }));
//   };

//   const handleAddDoc = async () => {
//     if (!newDocName.trim()) {
//       showSnackbar("Please enter document name", "warning");
//       return;
//     }

//     setDocsModal(prev => ({ ...prev, loading: true }));

//     try {
//       await api.post(`/claim-mgmt/additional-docs/${docsModal.claimId}/`, {
//         name: newDocName.trim(),
//       });

//       showSnackbar("Document request added successfully", "success");
//       setNewDocName("");
      
//       const freshDocs = await fetchAdditionalDocs(docsModal.claimId);
//       setDocsModal(prev => ({ ...prev, docs: freshDocs, loading: false }));
//     } catch (err) {
//       console.error("addDoc", err);
//       showSnackbar("Failed to add document request", "error");
//       setDocsModal(prev => ({ ...prev, loading: false }));
//     }
//   };

//   const handleEditClick = (id) => {
//     const claim = rows.find((row) => row.id === id);
//     if (claim) {
//       const statusObj =
//         claim.fullData.claim_status_base && claim.fullData.claim_status_base[0]
//           ? claim.fullData.claim_status_base[0]
//           : { is_verified_1: false };
//       const remarksObj =
//         claim.fullData.claim_rem_base && claim.fullData.claim_rem_base[0]
//           ? claim.fullData.claim_rem_base[0]
//           : { ver_1_remarks: "" };
//       const totalObj =
//         claim.fullData.total && claim.fullData.total[0]
//           ? claim.fullData.total[0]
//           : { ver1_assesment_amt: "" };

//       setEditFormData({
//         ver_1_remarks: remarksObj.ver_1_remarks || "",
//         ver1_assesment_amt: totalObj.ver1_assesment_amt || "",
//         is_verified_1: statusObj.is_verified_1 || false,
//       });
//       setSelectedClaimId(id);
//       setShowEditModal(true);
//     }
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setSelectedClaimId(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setEditFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleEditSubmit = async () => {
//     try {
//       const payload = {
//         is_verified_1: editFormData.is_verified_1,
//         ver_1_remarks: editFormData.ver_1_remarks,
//         ver1_assesment_amt: editFormData.ver1_assesment_amt,
//       };

//       await api.patch(
//         `/claim-mgmt/ver1-claims-mgmt/${selectedClaimId}/`,
//         payload
//       );

//       showSnackbar("Claim updated successfully", "success");
//       handleCloseEditModal();
      
//       // Refresh the entire table data
//       await fetchClaims();
      
//     } catch (error) {
//       console.error("Update error", error);
//       showSnackbar("Failed to update claim", "error");
//     }
//   };

//   const columns = [
//     { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
//     {
//       id: "claimant_name",
//       field: "claimant_name",
//       headerName: "Name Of Claimant",
//       width: 220,
//     },
//     { id: "fe_name", field: "fe_name", headerName: "FE Name", width: 180 },
   
//     { id: "ack_no", field: "ack_no", headerName: "Acknowledgment No", width: 240 },
//     { id: "created", field: "created", headerName: "Applied Date", width: 150 },

//      {
//       id: "application_type",
//       field: "application_type",
//       headerName: "Application Type",
//       width: 140,
//       renderCell: (params) => (
//         <Chip
//           label={params.value}
//           color={params.value === "Normal" ? "success" : "warning"}
//           variant="outlined"
//           size="small"
//         />
//       ),
//     },
//     // {
//     //   id: "status",
//     //   field: "status",
//     //   headerName: "Status",
//     //   width: 140,
//     //   renderCell: (params) => (
//     //     <Chip
//     //       label={params.value}
//     //       color={getStatusColor(params.value)}
//     //       variant="outlined"
//     //       size="small"
//     //     />
//     //   ),
//     // },
//     {
//       id: "request_docs",
//       field: "request_docs",
//       headerName: "Request Docs",
//       width: 140,
//       renderCell: (params) => (
//         <Button
//           variant="outlined"
//           size="small"
//           onClick={() => handleRequestDocsClick(params.row.id)}
//           sx={{ minWidth: "auto", px: 1 }}
//         >
//           Request Docs
//         </Button>
//       ),
//     },
//     {
//       id: "actions",
//       field: "actions",
//       headerName: "Actions",
//       width: 140,
//       renderCell: (params) => (
//         <>
//           <IconButton
//             color="primary"
//             onClick={() => setSelectedClaimId(params.row.id)}
//             title="View Claim"
//           >
//             <Visibility />
//           </IconButton>
//           <IconButton
//             color="secondary"
//             onClick={() => handleEditClick(params.row.id)}
//             title="Edit Claim"
//           >
//             <Edit />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   if (selectedClaimId && !showEditModal) {
//     return (
//       <Box sx={{ p: 3 }}>
//         <Button
//           variant="contained"
//           onClick={() => setSelectedClaimId(null)}
//           sx={{ mb: 2 }}
//         >
//           Back to Claims
//         </Button>
//         <ClaimDetailPage pk={selectedClaimId} claim_url={"ver1-claims-mgmt"}  />
//       </Box>
//     );
//   }

//   const selectedClaim =
//     rows.find((row) => row.id === selectedClaimId)?.fullData || {};

//   const totalObj =
//     selectedClaim.total && selectedClaim.total[0]
//       ? selectedClaim.total[0]
//       : { total_claim: "-", is_claim_amt_mached: null };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="h4">Claims To Verify</Typography>
//       </Box>

//       {/* FE Filter Section */}
//       <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
//         <Typography variant="body1" fontWeight="medium">
//           Filter by FE:
//         </Typography>
//         <FormControl sx={{ minWidth: 200 }}>
//           <InputLabel id="fe-filter-label">Select FE</InputLabel>
//           <Select
//             labelId="fe-filter-label"
//             value={feFilter}
//             label="Select FE"
//             onChange={handleFeFilterChange}
//             size="small"
//           >
//             <MenuItem value="all">All FEs</MenuItem>
//             {uniqueFEs.map((fe) => (
//               <MenuItem key={fe} value={fe}>
//                 {fe}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//         {feFilter !== "all" && (
//           <Chip 
//             label={`Showing: ${feFilter}`} 
//             color="primary" 
//             variant="outlined"
//             onDelete={() => setFeFilter("all")}
//           />
//         )}
//       </Box>

//       {loading ? (
//         <LoadingSpinner />
//       ) : (
//         <TableComponent
//           rows={rows}
//           columns={columns}
//           manageColumnStatus
//           enableSort="true"
//         />
//       )}

//       <SnackBarComponent
//         open={snackbar.open}
//         message={snackbar.message}
//         severity={snackbar.severity}
//         onClose={closeSnackbar}
//       />

//       {/* Request Docs Modal with 2 Tabs */}
//       <Modal
//         open={docsModal.open}
//         onClose={() => setDocsModal({ open: false, claimId: null, docs: [], loading: false, activeTab: 0 })}
//       >
//         <Box sx={docsStyle}>
//           <Box sx={{ p: 3, borderBottom: 1, borderColor: "divider" }}>
//             <Box display="flex" justifyContent="space-between" alignItems="center">
//               <Typography variant="h6">Request Documents</Typography>
//               <IconButton
//                 onClick={() => setDocsModal({ open: false, claimId: null, docs: [], loading: false, activeTab: 0 })}
//                 size="small"
//               >
//                 <CloseIcon />
//               </IconButton>
//             </Box>
//           </Box>

//           <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
//             <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
//               <Tabs
//                 value={docsModal.activeTab}
//                 onChange={handleDocsTabChange}
//                 centered
//               >
//                 <Tab label="Add Request" />
//                 <Tab label="View All" />
//               </Tabs>
//             </Box>

//             <Box sx={{ flex: 1, p: 3, overflow: "auto" }}>
//               {docsModal.loading ? (
//                 <Box display="flex" justifyContent="center" alignItems="center" height="100%">
//                   <CircularProgress />
//                 </Box>
//               ) : docsModal.activeTab === 0 ? (
//                 <Stack spacing={2}>
//                   <TextField
//                     label="Document Name"
//                     value={newDocName}
//                     onChange={(e) => setNewDocName(e.target.value)}
//                     fullWidth
//                     placeholder="Enter document name (e.g., Bank Statement, ID Proof)"
//                   />
//                   <Box display="flex" justifyContent="flex-end" gap={1}>
//                     <Button
//                       variant="contained"
//                       onClick={handleAddDoc}
//                       disabled={!newDocName.trim()}
//                     >
//                       Add Document
//                     </Button>
//                   </Box>
//                   <Typography variant="body2" color="textSecondary">
//                     Add unlimited document requests one by one. Modal stays open.
//                   </Typography>
//                 </Stack>
//               ) : (
//                 <List sx={{ maxHeight: 400, overflow: "auto" }}>
//                   {docsModal.docs.map((doc) => (
//                     <ListItem 
//                       key={doc.id} 
//                       divider
//                       sx={{ 
//                         cursor: doc.document ? 'pointer' : 'default',
//                         '&:hover': { 
//                           backgroundColor: doc.document ? 'action.hover' : 'transparent' 
//                         } 
//                       }}
//                       onClick={() => {
//                         if (doc.document) {
//                           window.open(doc.document, '_blank');
//                         }
//                       }}
//                     >
//                       <ListItemText
//                         primary={
//                           <Box display="flex" alignItems="center" gap={1}>
//                             <Typography variant="body1" fontWeight="medium">
//                               {doc.name || "Document"}
//                             </Typography>
//                             {doc.document && (
//                               <Chip 
//                                 label="View" 
//                                 size="small" 
//                                 color="primary"
//                                 component="span"
//                                 sx={{ ml: 1 }}
//                               />
//                             )}
//                           </Box>
//                         }
//                         secondary={
//                           doc.document && doc.is_submited
//                             ? `Uploaded: ${doc.document.split("/").pop()}`
//                             : doc.is_submited
//                             ? "Submitted ✓"
//                             : "Pending ⏳"
//                         }
//                       />
//                     </ListItem>
//                   ))}
//                   {docsModal.docs.length === 0 && (
//                     <Typography variant="body2" color="textSecondary" textAlign="center" p={3}>
//                       No documents requested yet. Switch to "Add Request" tab to start.
//                     </Typography>
//                   )}
//                 </List>
//               )}
//             </Box>
//           </Box>
//         </Box>
//       </Modal>

//       {/* Edit Claim Modal - YOUR ORIGINAL COMPACT STYLE */}
//       <Modal
//         open={showEditModal}
//         onClose={handleCloseEditModal}
//         aria-labelledby="edit-claim-modal-title"
//       >
//         <Box sx={editStyle}>
//           <Typography id="edit-claim-modal-title" variant="h6" mb={2}>
//             Edit Claim Verification
//           </Typography>
//           <Stack spacing={2}>
//             {/* Read-only fields */}
//             <Typography variant="subtitle2" color="textSecondary">
//               Total Claimed Amount
//             </Typography>
//             <Typography variant="body1" sx={{ mb: 1 }}>
//               {totalObj.total_claim || "-"}
//             </Typography>
//             <Typography variant="subtitle2" color="textSecondary">
//               Is Claimed Amount Matched With Legecy Data?
//             </Typography>
//             <Typography variant="body1" sx={{ mb: 2 }}>
//               {totalObj.is_claim_amt_mached !== null
//                 ? String(totalObj.is_claim_amt_mached)
//                 : "N/A"}
//             </Typography>

//             {/* Editable inputs */}
//             <TextField
//               label="Verifier 1 Remarks"
//               multiline
//               minRows={3}
//               name="ver_1_remarks"
//               value={editFormData.ver_1_remarks}
//               onChange={handleInputChange}
//               fullWidth
//             />
//             <TextField
//               label="Verifier 1 Assessment Amount"
//               name="ver1_assesment_amt"
//               value={editFormData.ver1_assesment_amt}
//               onChange={handleInputChange}
//               fullWidth
//             />
//             <Box display="flex" alignItems="center">
//               <input
//                 type="checkbox"
//                 id="is_verified_1"
//                 name="is_verified_1"
//                 checked={editFormData.is_verified_1}
//                 onChange={handleInputChange}
//               />
//               <label htmlFor="is_verified_1" style={{ marginLeft: 8 }}>
//                 Verified 1
//               </label>
//             </Box>
//             <Box display="flex" justifyContent="flex-end" mt={2}>
//               <Button variant="contained" onClick={handleEditSubmit}>
//                 Save
//               </Button>
//               <Button
//                 variant="outlined"
//                 onClick={handleCloseEditModal}
//                 sx={{ ml: 1 }}
//               >
//                 Cancel
//               </Button>
//             </Box>
//           </Stack>
//         </Box>
//       </Modal>
//     </Box>
//   );
// }


// v pre without amount validation
// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   Chip,
//   Modal,
//   TextField,
//   Stack,
//   List,
//   ListItem,
//   ListItemText,
//   Tabs,
//   Tab,
//   CircularProgress,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   FormControlLabel,
//   RadioGroup,
//   Radio,
// } from "@mui/material";
// import {
//   Visibility,
//   Edit,
//   Close as CloseIcon,
// } from "@mui/icons-material";
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import api from "../../../api/axiosInterceptor";
// import { API_BASE_URL } from "../../../config";
// import TableComponent from "../../../Components/TableComponent/TableComponent";
// import { LoadingSpinner } from "../../../Components/spinner/spinner";
// import { SnackBarComponent } from "../../../Components/snackBar/snackBar";
// import ClaimDetailPage from "../claimView";

// // Docs modal style (taller for tabs)
// const docsStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 600,
//   maxHeight: "80vh",
//   bgcolor: "background.paper",
//   borderRadius: 2,
//   boxShadow: 24,
//   p: 0,
//   display: "flex",
//   flexDirection: "column",
// };

// // Edit modal style (your original compact style)
// const editStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   borderRadius: 2,
//   boxShadow: 24,
//   p: 4,
// };

// export default function ClaimVer1List() {
//   const [rows, setRows] = useState([]);
//   const [originalRows, setOriginalRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });
//   const [selectedClaimId, setSelectedClaimId] = useState(null);
//   const [showEditModal, setShowEditModal] = useState(false);

//   // Filter states
//   const [feFilter, setFeFilter] = useState("all");
//   const [uniqueFEs, setUniqueFEs] = useState([]);

//   // Docs Modal states
//   const [docsModal, setDocsModal] = useState({
//     open: false,
//     claimId: null,
//     docs: [],
//     loading: false,
//     activeTab: 0,
//   });
//   const [newDocName, setNewDocName] = useState("");

//   const showSnackbar = (msg, sev = "info") =>
//     setSnackbar({ open: true, message: msg, severity: sev });
//   const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "Rejected":
//         return "error";
//       case "CA Verified":
//         return "success";
//       case "In Progress":
//         return "warning";
//       case "Submitted":
//         return "info";
//       case "Draft":
//         return "default";
//       default:
//         return "default";
//     }
//   };

//   const getApplicationType = (isNormal, isDelayed) => {
//     if (isNormal) return "Normal";
//     if (isDelayed) return "Delayed";
//     return "Normal";
//   };

//   const fetchClaims = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get(`/claim-mgmt/ver1-claims-mgmt/`);
//       const data = await Promise.all(
//         res.data.map(async (item, idx) => {
//           const csb = Array.isArray(item.claim_status_base)
//             ? item.claim_status_base[0]
//             : item.claim_status_base;

//           const status = csb
//             ? csb.is_rejected
//               ? "Rejected"
//               : csb.is_ca_verified
//               ? "CA Verified"
//               : csb.is_verified_2 || csb.is_verified_1
//               ? "In Progress"
//               : csb.is_submited
//               ? "Submitted"
//               : "Draft"
//             : "Unknown";

//           let additionalDocsData = [];
//           try {
//             const docsRes = await api.get(
//               `/claim-mgmt/additional-docs1/${item.id}/`
//             );
//             additionalDocsData = docsRes.data || [];
//           } catch (err) {
//             additionalDocsData = [];
//           }

//           return {
//             id: item.id,
//             slNo: idx + 1,
//             claimant_name: item.name_of_claimant1 || "-",
//             fe_name: item.fe_name || "-",
//             ack_no: item.ack_no || "-",
//             application_type: getApplicationType(item.is_normal, item.is_delayed),
//             created: item.created
//               ? new Date(item.created).toLocaleDateString("en-GB")
//               : "-",
//             status,
//             additionalDocsData,
//             fullData: item,
//           };
//         })
//       );

//       setOriginalRows(data);

//       if (feFilter === "all") {
//         setRows(data);
//       } else {
//         const filtered = data.filter(row => row.fe_name === feFilter);
//         setRows(filtered);
//       }

//       const feNames = [...new Set(data.map(row => row.fe_name).filter(name => name && name !== "-"))];
//       setUniqueFEs(feNames);
//     } catch (err) {
//       console.error("fetchClaims", err);
//       showSnackbar("Failed to load claims", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleFeFilterChange = (event) => {
//     const value = event.target.value;
//     setFeFilter(value);

//     if (value === "all") {
//       setRows(originalRows);
//     } else {
//       const filtered = originalRows.filter(row => row.fe_name === value);
//       setRows(filtered);
//     }
//   };

//   const fetchAdditionalDocs = async (claimId) => {
//     try {
//       const res = await api.get(`/claim-mgmt/additional-docs1/${claimId}/`);
//       return res.data || [];
//     } catch (err) {
//       console.error("fetchAdditionalDocs", err);
//       return [];
//     }
//   };

//   useEffect(() => {
//     fetchClaims();
//   }, []);

//   const handleRequestDocsClick = async (claimId) => {
//     setDocsModal({ open: true, claimId, docs: [], loading: true, activeTab: 0 });
//     const docs = await fetchAdditionalDocs(claimId);
//     setDocsModal(prev => ({ ...prev, docs, loading: false }));
//   };

//   const handleDocsTabChange = (event, newValue) => {
//     setDocsModal(prev => ({ ...prev, activeTab: newValue }));
//   };

//   const handleAddDoc = async () => {
//     if (!newDocName.trim()) {
//       showSnackbar("Please enter document name", "warning");
//       return;
//     }

//     setDocsModal(prev => ({ ...prev, loading: true }));

//     try {
//       await api.post(`/claim-mgmt/additional-docs/${docsModal.claimId}/`, {
//         name: newDocName.trim(),
//       });

//       showSnackbar("Document request added successfully", "success");
//       setNewDocName("");

//       const freshDocs = await fetchAdditionalDocs(docsModal.claimId);
//       setDocsModal(prev => ({ ...prev, docs: freshDocs, loading: false }));
//     } catch (err) {
//       console.error("addDoc", err);
//       showSnackbar("Failed to add document request", "error");
//       setDocsModal(prev => ({ ...prev, loading: false }));
//     }
//   };

//   // Formik with number validation
//   const formik = useFormik({
//     initialValues: {
//       ver_1_remarks: '',
//       ver1_assesment_amt: '',
//       is_claim_amt_mached: false,
//     },
//     validationSchema: Yup.object({
//       ver1_assesment_amt: Yup.number()
//         .typeError('Must be a number')
//         .positive('Must be greater than 0')
//         .required('Assessment amount is required'),
//     }),
//     onSubmit: async (values) => {
//       try {
//         const payload = {
//           is_verified_1: true, // Always true when moving to Verifier 2
//           ver_1_remarks: values.ver_1_remarks,
//           ver1_assesment_amt: values.ver1_assesment_amt,
//           is_claim_amt_mached: values.is_claim_amt_mached,
//         };

//         await api.patch(
//           `/claim-mgmt/ver1-claims-mgmt/${selectedClaimId}/`,
//           payload
//         );

//         showSnackbar("Application moved to Verifier 2 successfully", "success");
//         handleCloseEditModal();
//         await fetchClaims();
//       } catch (error) {
//         console.error("Update error", error);
//         showSnackbar("Failed to move application", "error");
//       }
//     },
//   });

//   const handleEditClick = (id) => {
//     const claim = rows.find((row) => row.id === id);
//     if (claim) {
//       const statusObj = claim.fullData.claim_status_base && claim.fullData.claim_status_base[0]
//         ? claim.fullData.claim_status_base[0]
//         : { is_verified_1: false };
//       const remarksObj = claim.fullData.claim_rem_base && claim.fullData.claim_rem_base[0]
//         ? claim.fullData.claim_rem_base[0]
//         : { ver_1_remarks: "" };
//       const totalObj = claim.fullData.total && claim.fullData.total[0]
//         ? claim.fullData.total[0]
//         : { ver1_assesment_amt: "", is_claim_amt_mached: null };

//       // Set form values
//       formik.setValues({
//         ver_1_remarks: remarksObj.ver_1_remarks || '',
//         ver1_assesment_amt: totalObj.ver1_assesment_amt || '',
//         is_claim_amt_mached: totalObj.is_claim_amt_mached !== null ? totalObj.is_claim_amt_mached : false,
//       });

//       setSelectedClaimId(id);
//       setShowEditModal(true);
//     }
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setSelectedClaimId(null);
//     formik.resetForm();
//   };

//   const columns = [
//     { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
//     {
//       id: "claimant_name",
//       field: "claimant_name",
//       headerName: "Name Of Claimant",
//       width: 220,
//     },
//     { id: "fe_name", field: "fe_name", headerName: "FE Name", width: 180 },
//     { id: "ack_no", field: "ack_no", headerName: "Acknowledgment No", width: 240 },
//     { id: "created", field: "created", headerName: "Applied Date", width: 150 },
//     {
//       id: "application_type",
//       field: "application_type",
//       headerName: "Application Type",
//       width: 140,
//       renderCell: (params) => (
//         <Chip
//           label={params.value}
//           color={params.value === "Normal" ? "success" : "warning"}
//           variant="outlined"
//           size="small"
//         />
//       ),
//     },
//     {
//       id: "request_docs",
//       field: "request_docs",
//       headerName: "Request Docs",
//       width: 140,
//       renderCell: (params) => (
//         <Button
//           variant="outlined"
//           size="small"
//           onClick={() => handleRequestDocsClick(params.row.id)}
//           sx={{ minWidth: "auto", px: 1 }}
//         >
//           Request Docs
//         </Button>
//       ),
//     },
//     {
//       id: "actions",
//       field: "actions",
//       headerName: "Actions",
//       width: 140,
//       renderCell: (params) => (
//         <>
//           <IconButton
//             color="primary"
//             onClick={() => setSelectedClaimId(params.row.id)}
//             title="View Claim"
//           >
//             <Visibility />
//           </IconButton>
//           <IconButton
//             color="secondary"
//             onClick={() => handleEditClick(params.row.id)}
//             title="Edit Claim"
//           >
//             <Edit />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   if (selectedClaimId && !showEditModal) {
//     return (
//       <Box sx={{ p: 3 }}>
//         <Button
//           variant="contained"
//           onClick={() => setSelectedClaimId(null)}
//           sx={{ mb: 2 }}
//         >
//           Back to Claims
//         </Button>
//         <ClaimDetailPage pk={selectedClaimId} claim_url={"ver1-claims-mgmt"} />
//       </Box>
//     );
//   }

//   const selectedClaim =
//     rows.find((row) => row.id === selectedClaimId)?.fullData || {};

//   const totalObj =
//     selectedClaim.total && selectedClaim.total[0]
//       ? selectedClaim.total[0]
//       : { total_claim: "-", is_claim_amt_mached: null };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="h4">Claims To Verify</Typography>
//       </Box>

//       {/* FE Filter Section */}
//       <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
//         <Typography variant="body1" fontWeight="medium">
//           Filter by FE:
//         </Typography>
//         <FormControl sx={{ minWidth: 200 }}>
//           <InputLabel id="fe-filter-label">Select FE</InputLabel>
//           <Select
//             labelId="fe-filter-label"
//             value={feFilter}
//             label="Select FE"
//             onChange={handleFeFilterChange}
//             size="small"
//           >
//             <MenuItem value="all">All FEs</MenuItem>
//             {uniqueFEs.map((fe) => (
//               <MenuItem key={fe} value={fe}>
//                 {fe}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//         {feFilter !== "all" && (
//           <Chip
//             label={`Showing: ${feFilter}`}
//             color="primary"
//             variant="outlined"
//             onDelete={() => setFeFilter("all")}
//           />
//         )}
//       </Box>

//       {loading ? (
//         <LoadingSpinner />
//       ) : (
//         <TableComponent
//           rows={rows}
//           columns={columns}
//           manageColumnStatus
//           enableSort="true"
//         />
//       )}

//       <SnackBarComponent
//         open={snackbar.open}
//         message={snackbar.message}
//         severity={snackbar.severity}
//         onClose={closeSnackbar}
//       />

//       {/* Request Docs Modal - UNCHANGED */}
//       <Modal
//         open={docsModal.open}
//         onClose={() => setDocsModal({ open: false, claimId: null, docs: [], loading: false, activeTab: 0 })}
//       >
//         <Box sx={docsStyle}>
//           <Box sx={{ p: 3, borderBottom: 1, borderColor: "divider" }}>
//             <Box display="flex" justifyContent="space-between" alignItems="center">
//               <Typography variant="h6">Request Documents</Typography>
//               <IconButton
//                 onClick={() => setDocsModal({ open: false, claimId: null, docs: [], loading: false, activeTab: 0 })}
//                 size="small"
//               >
//                 <CloseIcon />
//               </IconButton>
//             </Box>
//           </Box>

//           <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
//             <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
//               <Tabs
//                 value={docsModal.activeTab}
//                 onChange={handleDocsTabChange}
//                 centered
//               >
//                 <Tab label="Add Request" />
//                 <Tab label="View All" />
//               </Tabs>
//             </Box>

//             <Box sx={{ flex: 1, p: 3, overflow: "auto" }}>
//               {docsModal.loading ? (
//                 <Box display="flex" justifyContent="center" alignItems="center" height="100%">
//                   <CircularProgress />
//                 </Box>
//               ) : docsModal.activeTab === 0 ? (
//                 <Stack spacing={2}>
//                   <TextField
//                     label="Document Name"
//                     value={newDocName}
//                     onChange={(e) => setNewDocName(e.target.value)}
//                     fullWidth
//                     placeholder="Enter document name (e.g., Bank Statement, ID Proof)"
//                   />
//                   <Box display="flex" justifyContent="flex-end" gap={1}>
//                     <Button
//                       variant="contained"
//                       onClick={handleAddDoc}
//                       disabled={!newDocName.trim()}
//                     >
//                       Add Document
//                     </Button>
//                   </Box>
//                   <Typography variant="body2" color="textSecondary">
//                     Add unlimited document requests one by one. Modal stays open.
//                   </Typography>
//                 </Stack>
//               ) : (
//                 <List sx={{ maxHeight: 400, overflow: "auto" }}>
//                   {docsModal.docs.map((doc) => (
//                     <ListItem
//                       key={doc.id}
//                       divider
//                       sx={{
//                         cursor: doc.document ? 'pointer' : 'default',
//                         '&:hover': {
//                           backgroundColor: doc.document ? 'action.hover' : 'transparent'
//                         }
//                       }}
//                       onClick={() => {
//                         if (doc.document) {
//                           window.open(doc.document, '_blank');
//                         }
//                       }}
//                     >
//                       <ListItemText
//                         primary={
//                           <Box display="flex" alignItems="center" gap={1}>
//                             <Typography variant="body1" fontWeight="medium">
//                               {doc.name || "Document"}
//                             </Typography>
//                             {doc.document && (
//                               <Chip
//                                 label="View"
//                                 size="small"
//                                 color="primary"
//                                 component="span"
//                                 sx={{ ml: 1 }}
//                               />
//                             )}
//                           </Box>
//                         }
//                         secondary={
//                           doc.document && doc.is_submited
//                             ? `Uploaded: ${doc.document.split("/").pop()}`
//                             : doc.is_submited
//                             ? "Submitted ✓"
//                             : "Pending ⏳"
//                         }
//                       />
//                     </ListItem>
//                   ))}
//                   {docsModal.docs.length === 0 && (
//                     <Typography variant="body2" color="textSecondary" textAlign="center" p={3}>
//                       No documents requested yet. Switch to "Add Request" tab to start.
//                     </Typography>
//                   )}
//                 </List>
//               )}
//             </Box>
//           </Box>
//         </Box>
//       </Modal>

//       {/* Edit Claim Modal - EXACTLY LIKE YOUR OLD CODE + VALIDATION */}
//       <Modal
//         open={showEditModal}
//         onClose={handleCloseEditModal}
//         aria-labelledby="edit-claim-modal-title"
//       >
//         <Box sx={editStyle}>
//           <Typography id="edit-claim-modal-title" variant="h6" mb={2}>
//             Move Application to Verifier 2
//           </Typography>
//           <form onSubmit={formik.handleSubmit} noValidate>
//             <Stack spacing={2}>
//               {/* Read-only fields - EXACTLY YOUR ORIGINAL */}
//               <Typography variant="subtitle2" color="textSecondary">
//                 Total Claimed Amount
//               </Typography>
//               <Typography variant="body1" sx={{ mb: 1 }}>
//                 {totalObj.total_claim || "-"}
//               </Typography>
//               <Typography variant="subtitle2" color="textSecondary">
//                 Is Claimed Amount Matched With Legacy Data?
//               </Typography>
//               {/* ✅ SHOWS API VALUE LIKE YOUR OLD CODE */}
//               <Typography variant="body1" sx={{ mb: 2 }}>
//                 {totalObj.is_claim_amt_mached !== null
//                   ? totalObj.is_claim_amt_mached ? "Yes" : "No"
//                   : "N/A"}
//               </Typography>

//               {/* ✅ ONLY assessment amount has number validation */}
//               <TextField
//                 label="Verifier 1 Remarks"
//                 multiline
//                 minRows={3}
//                 name="ver_1_remarks"
//                 value={formik.values.ver_1_remarks}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 fullWidth
//               />
//               <TextField
//                 label="Verifier 1 Assessment Amount"
//                 name="ver1_assesment_amt"
//                 type="number"
//                 value={formik.values.ver1_assesment_amt}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 fullWidth
//                 error={formik.touched.ver1_assesment_amt && Boolean(formik.errors.ver1_assesment_amt)}
//                 helperText={formik.touched.ver1_assesment_amt && formik.errors.ver1_assesment_amt}
//                 inputProps={{ step: '0.01', min: '0' }}
//               />

//               <Box display="flex" justifyContent="flex-end" mt={2} gap={1}>
//                 <Button 
//                   type="submit" 
//                   variant="contained" 
//                   disabled={formik.isSubmitting || !formik.isValid}
//                 >
//                   Move Application to Verifier 2
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   onClick={handleCloseEditModal}
//                   disabled={formik.isSubmitting}
//                 >
//                   Cancel
//                 </Button>
//               </Box>
//             </Stack>
//           </form>
//         </Box>
//       </Modal>
//     </Box>
//   );
// }


// v final
import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Chip,
  Modal,
  TextField,
  Stack,
  List,
  ListItem,
  ListItemText,
  Tabs,
  Tab,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import {
  Visibility,
  Edit,
  Close as CloseIcon,
} from "@mui/icons-material";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import api from "../../../api/axiosInterceptor";
import { API_BASE_URL } from "../../../config";
import TableComponent from "../../../Components/TableComponent/TableComponent";
import { LoadingSpinner } from "../../../Components/spinner/spinner";
import { SnackBarComponent } from "../../../Components/snackBar/snackBar";
import ClaimDetailPage from "../claimView";

// Docs modal style (taller for tabs)
const docsStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  maxHeight: "80vh",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 0,
  display: "flex",
  flexDirection: "column",
};

// Edit modal style (your original compact style)
const editStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

export default function ClaimVer1List() {
  const [rows, setRows] = useState([]);
  const [originalRows, setOriginalRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [selectedClaimId, setSelectedClaimId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);

  // Filter states
  const [feFilter, setFeFilter] = useState("all");
  const [uniqueFEs, setUniqueFEs] = useState([]);

  // Docs Modal states
  const [docsModal, setDocsModal] = useState({
    open: false,
    claimId: null,
    docs: [],
    loading: false,
    activeTab: 0,
  });
  const [newDocName, setNewDocName] = useState("");

  // ✅ NEW: Store claimed amount for validation
  const [claimedAmount, setClaimedAmount] = useState(0);

  const showSnackbar = (msg, sev = "info") =>
    setSnackbar({ open: true, message: msg, severity: sev });
  const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const getStatusColor = (status) => {
    switch (status) {
      case "Rejected":
        return "error";
      case "CA Verified":
        return "success";
      case "In Progress":
        return "warning";
      case "Submitted":
        return "info";
      case "Draft":
        return "default";
      default:
        return "default";
    }
  };

  const getApplicationType = (isNormal, isDelayed) => {
    if (isNormal) return "Normal";
    if (isDelayed) return "Delayed";
    return "Normal";
  };

  const fetchClaims = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/claim-mgmt/ver1-claims-mgmt/`);
      const data = await Promise.all(
        res.data.map(async (item, idx) => {
          const csb = Array.isArray(item.claim_status_base)
            ? item.claim_status_base[0]
            : item.claim_status_base;

          const status = csb
            ? csb.is_rejected
              ? "Rejected"
              : csb.is_ca_verified
              ? "CA Verified"
              : csb.is_verified_2 || csb.is_verified_1
              ? "In Progress"
              : csb.is_submited
              ? "Submitted"
              : "Draft"
            : "Unknown";

          let additionalDocsData = [];
          try {
            const docsRes = await api.get(
              `/claim-mgmt/additional-docs1/${item.id}/`
            );
            additionalDocsData = docsRes.data || [];
          } catch (err) {
            additionalDocsData = [];
          }

          return {
            id: item.id,
            slNo: idx + 1,
            // claimant_name: item.name_of_claimant1 || "-",
            claimant_name:
              item.claiment_type === "self"
                ? item.name_of_claimant1 || "-"
                : item.claiment_type === "nominee"
                ? item.nominee?.[0]?.name || "-"
                : item.claiment_type === "legal_heir"
                ? item.legalHeir?.[0]?.name || "-"
                : item.name_of_claimant1 || "-",
            fe_name: item.fe_name || "-",
            ack_no: item.ack_no || "-",
            application_type: getApplicationType(item.is_normal, item.is_delayed),
            created: item.created
              ? new Date(item.created).toLocaleDateString("en-GB")
              : "-",
            status,
            additionalDocsData,
            fullData: item,
          };
        })
      );

      setOriginalRows(data);

      if (feFilter === "all") {
        setRows(data);
      } else {
        const filtered = data.filter(row => row.fe_name === feFilter);
        setRows(filtered);
      }

      const feNames = [...new Set(data.map(row => row.fe_name).filter(name => name && name !== "-"))];
      setUniqueFEs(feNames);
    } catch (err) {
      console.error("fetchClaims", err);
      showSnackbar("Failed to load claims", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleFeFilterChange = (event) => {
    const value = event.target.value;
    setFeFilter(value);

    if (value === "all") {
      setRows(originalRows);
    } else {
      const filtered = originalRows.filter(row => row.fe_name === value);
      setRows(filtered);
    }
  };

  const fetchAdditionalDocs = async (claimId) => {
    try {
      const res = await api.get(`/claim-mgmt/additional-docs1/${claimId}/`);
      return res.data || [];
    } catch (err) {
      console.error("fetchAdditionalDocs", err);
      return [];
    }
  };

  useEffect(() => {
    fetchClaims();
  }, []);

  const handleRequestDocsClick = async (claimId) => {
    setDocsModal({ open: true, claimId, docs: [], loading: true, activeTab: 0 });
    const docs = await fetchAdditionalDocs(claimId);
    setDocsModal(prev => ({ ...prev, docs, loading: false }));
  };

  const handleDocsTabChange = (event, newValue) => {
    setDocsModal(prev => ({ ...prev, activeTab: newValue }));
  };

  const handleAddDoc = async () => {
    if (!newDocName.trim()) {
      showSnackbar("Please enter document name", "warning");
      return;
    }

    setDocsModal(prev => ({ ...prev, loading: true }));

    try {
      await api.post(`/claim-mgmt/additional-docs/${docsModal.claimId}/`, {
        name: newDocName.trim(),
      });

      showSnackbar("Document request added successfully", "success");
      setNewDocName("");

      const freshDocs = await fetchAdditionalDocs(docsModal.claimId);
      setDocsModal(prev => ({ ...prev, docs: freshDocs, loading: false }));
    } catch (err) {
      console.error("addDoc", err);
      showSnackbar("Failed to add document request", "error");
      setDocsModal(prev => ({ ...prev, loading: false }));
    }
  };

  // ✅ CUSTOM VALIDATION FUNCTION - replaces context
  const validateForm = useCallback((values) => {
    const errors = {};
    
    if (values.ver1_assesment_amt) {
      const assessmentAmt = parseFloat(values.ver1_assesment_amt);
      if (isNaN(assessmentAmt)) {
        errors.ver1_assesment_amt = 'Must be a number';
      } else if (assessmentAmt <= 0) {
        errors.ver1_assesment_amt = 'Must be greater than 0';
      } else if (assessmentAmt > claimedAmount) {
        errors.ver1_assesment_amt = `Cannot exceed claimed amount (₹${claimedAmount.toLocaleString()})`;
      }
    }

    return errors;
  }, [claimedAmount]);

  // Formik - using custom validate function instead of Yup context
  const formik = useFormik({
    initialValues: {
      ver_1_remarks: '',
      ver1_assesment_amt: '',
      is_claim_amt_mached: false,
    },
    validate: validateForm,
    onSubmit: async (values) => {
      try {
        const payload = {
          is_verified_1: true,
          ver_1_remarks: values.ver_1_remarks,
          ver1_assesment_amt: values.ver1_assesment_amt,
          is_claim_amt_mached: values.is_claim_amt_mached,
        };

        await api.patch(
          `/claim-mgmt/ver1-claims-mgmt/${selectedClaimId}/`,
          payload
        );

        showSnackbar("Application moved to Verifier 2 successfully", "success");
        handleCloseEditModal();
        await fetchClaims();
      } catch (error) {
        console.error("Update error", error);
        showSnackbar("Failed to move application", "error");
      }
    },
  });

  const handleEditClick = (id) => {
    const claim = rows.find((row) => row.id === id);
    if (claim) {
      const statusObj = claim.fullData.claim_status_base && claim.fullData.claim_status_base[0]
        ? claim.fullData.claim_status_base[0]
        : { is_verified_1: false };
      const remarksObj = claim.fullData.claim_rem_base && claim.fullData.claim_rem_base[0]
        ? claim.fullData.claim_rem_base[0]
        : { ver_1_remarks: "" };
      const totalObj = claim.fullData.total && claim.fullData.total[0]
        ? claim.fullData.total[0]
        : { ver1_assesment_amt: "", is_claim_amt_mached: null };

      // ✅ Set claimed amount from API data
      const parsedClaimedAmount = parseFloat(totalObj.total_claim) || 0;
      setClaimedAmount(parsedClaimedAmount);

      // Set form values
      formik.setValues({
        ver_1_remarks: remarksObj.ver_1_remarks || '',
        ver1_assesment_amt: totalObj.ver1_assesment_amt || '',
        is_claim_amt_mached: totalObj.is_claim_amt_mached !== null ? totalObj.is_claim_amt_mached : false,
      });

      // Re-run validation with new claimed amount
      formik.validateForm();

      setSelectedClaimId(id);
      setShowEditModal(true);
    }
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedClaimId(null);
    setClaimedAmount(0); // Reset claimed amount
    formik.resetForm();
  };

  const columns = [
    { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
    {
      id: "claimant_name",
      field: "claimant_name",
      headerName: "Name Of Claimant",
      width: 220,
    },
    { id: "fe_name", field: "fe_name", headerName: "FE Name", width: 180 },
    { id: "ack_no", field: "ack_no", headerName: "Acknowledgment No", width: 240 },
    { id: "created", field: "created", headerName: "Applied Date", width: 150 },
    {
      id: "application_type",
      field: "application_type",
      headerName: "Application Type",
      width: 140,
      renderCell: (params) => (
        <Chip
          label={params.value}
          color={params.value === "Normal" ? "success" : "warning"}
          variant="outlined"
          size="small"
        />
      ),
    },
    {
      id: "request_docs",
      field: "request_docs",
      headerName: "Request Docs",
      width: 140,
      renderCell: (params) => (
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleRequestDocsClick(params.row.id)}
          sx={{ minWidth: "auto", px: 1 }}
        >
          Request Docs
        </Button>
      ),
    },
    {
      id: "actions",
      field: "actions",
      headerName: "Actions",
      width: 140,
      renderCell: (params) => (
        <>
          <IconButton
            color="primary"
            onClick={() => setSelectedClaimId(params.row.id)}
            title="View Claim"
          >
            <Visibility />
          </IconButton>
          <IconButton
            color="secondary"
            onClick={() => handleEditClick(params.row.id)}
            title="Edit Claim"
          >
            <Edit />
          </IconButton>
        </>
      ),
    },
  ];

  if (selectedClaimId && !showEditModal) {
    return (
      <Box sx={{ p: 3 }}>
        <Button
          variant="contained"
          onClick={() => setSelectedClaimId(null)}
          sx={{ mb: 2 }}
        >
          Back to Claims
        </Button>
        <ClaimDetailPage pk={selectedClaimId} claim_url={"ver1-claims-mgmt"} />
      </Box>
    );
  }

  const selectedClaim =
    rows.find((row) => row.id === selectedClaimId)?.fullData || {};

  const totalObj =
    selectedClaim.total && selectedClaim.total[0]
      ? selectedClaim.total[0]
      : { total_claim: "-", is_claim_amt_mached: null };

  return (
    <Box sx={{ p: 3 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">Claims To Verify</Typography>
      </Box>

      {/* FE Filter Section */}
      <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
        <Typography variant="body1" fontWeight="medium">
          Filter by FE:
        </Typography>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="fe-filter-label">Select FE</InputLabel>
          <Select
            labelId="fe-filter-label"
            value={feFilter}
            label="Select FE"
            onChange={handleFeFilterChange}
            size="small"
          >
            <MenuItem value="all">All FEs</MenuItem>
            {uniqueFEs.map((fe) => (
              <MenuItem key={fe} value={fe}>
                {fe}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {feFilter !== "all" && (
          <Chip
            label={`Showing: ${feFilter}`}
            color="primary"
            variant="outlined"
            onDelete={() => setFeFilter("all")}
          />
        )}
      </Box>

      {loading ? (
        <LoadingSpinner />
      ) : (
        <TableComponent
          rows={rows}
          columns={columns}
          manageColumnStatus
          enableSort="true"
        />
      )}

      <SnackBarComponent
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={closeSnackbar}
      />

      {/* Request Docs Modal - UNCHANGED */}
      <Modal
        open={docsModal.open}
        onClose={() => setDocsModal({ open: false, claimId: null, docs: [], loading: false, activeTab: 0 })}
      >
        <Box sx={docsStyle}>
          <Box sx={{ p: 3, borderBottom: 1, borderColor: "divider" }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Request Documents</Typography>
              <IconButton
                onClick={() => setDocsModal({ open: false, claimId: null, docs: [], loading: false, activeTab: 0 })}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>

          <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={docsModal.activeTab}
                onChange={handleDocsTabChange}
                centered
              >
                <Tab label="Add Request" />
                <Tab label="View All" />
              </Tabs>
            </Box>

            <Box sx={{ flex: 1, p: 3, overflow: "auto" }}>
              {docsModal.loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                  <CircularProgress />
                </Box>
              ) : docsModal.activeTab === 0 ? (
                <Stack spacing={2}>
                  <TextField
                    label="Document Name"
                    value={newDocName}
                    onChange={(e) => setNewDocName(e.target.value)}
                    fullWidth
                    placeholder="Enter document name (e.g., Bank Statement, ID Proof)"
                  />
                  <Box display="flex" justifyContent="flex-end" gap={1}>
                    <Button
                      variant="contained"
                      onClick={handleAddDoc}
                      disabled={!newDocName.trim()}
                    >
                      Add Document
                    </Button>
                  </Box>
                  <Typography variant="body2" color="textSecondary">
                    Add unlimited document requests one by one. Modal stays open.
                  </Typography>
                </Stack>
              ) : (
                <List sx={{ maxHeight: 400, overflow: "auto" }}>
                  {docsModal.docs.map((doc) => (
                    <ListItem
                      key={doc.id}
                      divider
                      sx={{
                        cursor: doc.document ? 'pointer' : 'default',
                        '&:hover': {
                          backgroundColor: doc.document ? 'action.hover' : 'transparent'
                        }
                      }}
                      onClick={() => {
                        if (doc.document) {
                          window.open(doc.document, '_blank');
                        }
                      }}
                    >
                      <ListItemText
                        primary={
                          <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="body1" fontWeight="medium">
                              {doc.name || "Document"}
                            </Typography>
                            {doc.document && (
                              <Chip
                                label="View"
                                size="small"
                                color="primary"
                                component="span"
                                sx={{ ml: 1 }}
                              />
                            )}
                          </Box>
                        }
                        secondary={
                          doc.document && doc.is_submited
                            ? `Uploaded: ${doc.document.split("/").pop()}`
                            : doc.is_submited
                            ? "Submitted ✓"
                            : "Pending ⏳"
                        }
                      />
                    </ListItem>
                  ))}
                  {docsModal.docs.length === 0 && (
                    <Typography variant="body2" color="textSecondary" textAlign="center" p={3}>
                      No documents requested yet. Switch to "Add Request" tab to start.
                    </Typography>
                  )}
                </List>
              )}
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Edit Claim Modal */}
      <Modal
        open={showEditModal}
        onClose={handleCloseEditModal}
        aria-labelledby="edit-claim-modal-title"
      >
        <Box sx={editStyle}>
          <Typography id="edit-claim-modal-title" variant="h6" mb={2}>
            Move Application to Verifier 2
          </Typography>
          <form onSubmit={formik.handleSubmit} noValidate>
            <Stack spacing={2}>
              {/* Read-only fields */}
              <Typography variant="subtitle2" color="textSecondary">
                Total Claimed Amount
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                ₹{claimedAmount.toLocaleString()} {claimedAmount === 0 && "(N/A)"}
              </Typography>
              <Typography variant="subtitle2" color="textSecondary">
                Is Claimed Amount Matched With Legacy Data?
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {totalObj.is_claim_amt_mached !== null
                  ? totalObj.is_claim_amt_mached ? "Yes" : "No"
                  : "N/A"}
              </Typography>

              <TextField
                label="Verifier 1 Remarks"
                multiline
                minRows={3}
                name="ver_1_remarks"
                value={formik.values.ver_1_remarks}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
              />
              <TextField
                label="Verifier 1 Assessment Amount"
                name="ver1_assesment_amt"
                type="number"
                value={formik.values.ver1_assesment_amt}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
                error={formik.touched.ver1_assesment_amt && Boolean(formik.errors.ver1_assesment_amt)}
                helperText={formik.touched.ver1_assesment_amt && formik.errors.ver1_assesment_amt}
                inputProps={{ step: '0.01', min: '0' }}
              />

              <Box display="flex" justifyContent="flex-end" mt={2} gap={1}>
                <Button 
                  type="submit" 
                  variant="contained" 
                  disabled={formik.isSubmitting || !formik.isValid}
                >
                  Move Application to Verifier 2
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleCloseEditModal}
                  disabled={formik.isSubmitting}
                >
                  Cancel
                </Button>
              </Box>
            </Stack>
          </form>
        </Box>
      </Modal>
    </Box>
  );
}
